<template>
	<div class="container-fluid bg-white">
		<expense-toolbar heading="Expenses"></expense-toolbar>

		<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

		<expense-table
			:show-user="true"
			:show-job="true"
			:editable="true"
			:filtering-tools="true">
		</expense-table>

	</div>
</template>

<script>
import ExpenseTable from "../components/super_components/ExpenseTable"
import ExpenseToolbar from "./expenses/ExpenseToolbar"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {

	name: 'Expenses',
	components: {
		ExpenseToolbar,
		ExpenseTable,
		FreemiumLockedAlert
	}

}
</script>
